<template>
  <!-- USERで表示される画面のプレビュー表示 -->
  <div
    id="contents"
    class="user-preview"
  >
    <!-- ヘッダーエリア -->
    <job-preview-header-sp
      :company-name="offer.companyInfo.name"
      :title="offer.description.jobTitle"
      :is-simple="offer.description.isSimple"
      :is-original-entry-form="offer.description.isOriginalEntryForm"
      :employment-status="offer.description.employmentStatus"
    />

    <!-- 写真/メイン記事/PRコード -->
    <job-preview-main-article-sp
      :company-name="offer.companyInfo.name"
      :title="offer.description.mainTitle"
      :body="offer.description.mainBody"
      :photo-data="offer.description.mainPhoto"
      :caption="offer.description.mainCaption"
      :pr-codes="offer.description.prCodes"
    />

    <!-- fixed-nav-areaの代用 -->
    <div class="blank-space" />

    <!-- 仕事内容 -->
    <job-preview-section-title-sp
      id="description"
      title="仕事内容"
    />
    <job-preview-description-sp :description="offer.description" />

    <!-- 募集要項 -->
    <job-preview-section-title-sp
      id="require"
      class="mt20"
      title="募集要項"
    />
    <div class="contents-inner">
      <job-preview-requirements-sp :requirements="offer.requirements" />

      <!-- フリートピックス -->
      <template v-for="(freeTopic, i) in getFreeTopics(offer, false)">
        <job-preview-free-topics-sp
          :key="i"
          :free-topic="freeTopic"
          :class="{'mt20':i===0}"
        />
      </template>
    </div>

    <!-- 働く環境の特徴 / この仕事の特徴 -->
    <job-preview-feature-sp :requirements="offer.requirements" />

    <!-- 女の転職！取材レポート-->
    <job-preview-view-points-sp
      v-if="!offer.description.isLightPlan && offer.requirements.report.body"
      :report="offer.requirements.report"
      :interviews="getFreeTopics(offer, true)"
    />

    <!-- 社員からの評判・口コミ -->
    <job-preview-real-intention-sp
      v-if="offer.realIntentions.length"
      :company-name="offer.companyInfo.name"
      :real-intentions="offer.realIntentions"
    />

    <!-- 会社概要 -->
    <job-preview-section-title-sp
      id="company"
      class="mt20"
      title="会社概要"
    />
    <job-preview-company-info-sp
      :is-light-plan="offer.description.isLightPlan"
      :company-info="offer.companyInfo"
    />

    <!-- 応募・選考 -->
    <job-preview-section-title-sp
      id="application"
      class="mt20"
      title="応募・選考"
    />
    <job-preview-selection-sp
      :company-name="offer.companyInfo.name"
      :selection="offer.selection"
    />

    <user-preview-menu-sp :titles="['写真で見る','社員インタビュー']" />

    <!-- データで見る働く環境(求人版) -->
    <job-preview-data-for-job-sp
      v-if="isShowEnvironment(offer.environment)"
      :company-name="offer.companyInfo.name"
      :environment="offer.environment"
    />

    <!-- 検討中・応募ボタン -->
    <job-preview-entry-button-sp
      :is-simple="offer.description.isSimple"
      :is-original-entry-form="offer.description.isOriginalEntryForm"
    />

    <template v-if="isShowEnvironment(offer.environment)">
      <div class="hide-msg mlr15 margin-top-1">
        「データをすべて見る」を押下すると、以下の内容が表示されます。
      </div>
      <div class="company-environments mt20 mb20">
        <!-- データで見る働く環境（企業情報版）-->
        <job-preview-data-for-company-sp :environment="offer.environment" />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewHeaderSp from '@/components/molecules/JobPreviewHeaderSp'
import JobPreviewMainArticleSp from '@/components/molecules/JobPreviewMainArticleSp'
import JobPreviewSectionTitleSp from '@/components/atoms/JobPreviewSectionTitleSp'
import JobPreviewDescriptionSp from '@/components/organisms/JobPreviewDescriptionSp'
import JobPreviewRequirementsSp from '@/components/organisms/JobPreviewRequirementsSp'
import JobPreviewFreeTopicsSp from '@/components/molecules/JobPreviewFreeTopicsSp'
import JobPreviewFeatureSp from '@/components/molecules/JobPreviewFeatureSp'
import JobPreviewViewPointsSp from '@/components/molecules/JobPreviewViewPointsSp'
import JobPreviewRealIntentionSp from '@/components/molecules/JobPreviewRealIntentionSp'
import JobPreviewCompanyInfoSp from '@/components/organisms/JobPreviewCompanyInfoSp'
import JobPreviewSelectionSp from '@/components/organisms/JobPreviewSelectionSp'
import UserPreviewMenuSp from '@/components/atoms/UserPreviewMenuSp'
import JobPreviewDataForJobSp from '@/components/molecules/JobPreviewDataForJobSp'
import JobPreviewEntryButtonSp from '@/components/atoms/JobPreviewEntryButtonSp'
import JobPreviewDataForCompanySp from '@/components/molecules/JobPreviewDataForCompanySp'

export default {
  components: {
    JobPreviewHeaderSp,
    JobPreviewMainArticleSp,
    JobPreviewSectionTitleSp,
    JobPreviewDescriptionSp,
    JobPreviewRequirementsSp,
    JobPreviewFreeTopicsSp,
    JobPreviewFeatureSp,
    JobPreviewViewPointsSp,
    JobPreviewRealIntentionSp,
    JobPreviewCompanyInfoSp,
    JobPreviewSelectionSp,
    UserPreviewMenuSp,
    JobPreviewDataForJobSp,
    JobPreviewEntryButtonSp,
    JobPreviewDataForCompanySp
  },
  mixins: [jobPreviewCommon],
  props: {
    offer: {
      type: Object,
      required: true
    }
  }
}
</script>
